import React, { PureComponent } from 'react';
import Utils from 'app/common/util/Utils';
import { MoreOutlined } from '@ant-design/icons';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import AppContext from 'app/common/context/AppContext';
import { FlightDto } from 'app/model/CORE';

import { ModalHandler } from '../panels/ModalHandler';
import { PopoverMenu } from '../common/PopoverMenu';

export interface FlightMoreMenuProps {
    flight: FlightDto;
}

export class FlightMoreMenu extends PureComponent<FlightMoreMenuProps> {
    private handleMoreMenuItemClick = (key: string) => {
        switch (key) {
            case 'network-improvement':
                ModalHandler.showFlightNetworkImprovement(this.props.flight);
                break;
            case 'show-details':
                ModalHandler.showFlightDetailsPanel(
                    this.props.flight.flightId,
                    this.props.flight.dataset,
                    this.props.flight.proposalContext,
                );
                break;
            case 'show-oplog':
                ModalHandler.showFlightOpLog(this.props.flight.flightId, this.props.flight.dataset);
                break;
        }
    };

    private getMenuItems = (mpr: string): ItemType[] => {
        return [
            { key: 'show-details', label: 'Show details' },
            { key: 'show-route', label: 'Show route', disabled: true },
            { key: 'show-oplog', label: 'Show OPLOG' },
            { key: 'divider-1', type: 'divider' },
            {
                key: 'network-improvement',
                label: 'Network improvement',
                disabled: AppContext.isOpsBaseline() || !Utils.isExists(mpr),
            },
        ];
    };

    public render() {
        const callsign = this.props.flight?.flightId?.flightKeys?.callsign;
        const mpr = this.props.flight?.mostPenalisingRegulation;
        return (
            <PopoverMenu
                title={callsign}
                placement="bottomRight"
                onMenuItemClick={this.handleMoreMenuItemClick}
                menuItems={this.getMenuItems(mpr)}>
                <MoreOutlined />
            </PopoverMenu>
        );
    }
}
